{
  "REPORT": {
    "HEADER": "Rozhovory",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_AGENT_REPORTS": "Stiahnutie reportov o agentoch",
    "DATA_FETCHING_FAILED": "Nepodarilo sa načítať údaje, skúste to prosím neskôr.",
    "SUMMARY_FETCHING_FAILED": "Nepodarilo sa načítať súhrn, skúste to prosím neskôr.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas prvej odpovede",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas prvej odpovede je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas vyriešenia je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Počet odovzdaní",
        "DESC": "( Spolu )"
      },
      "REPLY_TIME": {
        "NAME": "Čas čakania zákazníka",
        "TOOLTIP_TEXT": "Čas čakania je {metricValue} (na základe {conversationCount} odpovedí)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Posledných 7 dní",
      "LAST_30_DAYS": "Posledných 30 dní",
      "THIS_MONTH": "Tento mesiac",
      "LAST_MONTH": "Minulý mesiac",
      "LAST_3_MONTHS": "Posledné 3 mesiace",
      "LAST_6_MONTHS": "Posledných 6 mesiacov",
      "LAST_YEAR": "Posledný rok",
      "CUSTOM_DATE_RANGE": "Vlastný rozsah dátumov",
      "TODAY": "Dnes",
      "YESTERDAY": "Včera"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Zoskupiť podľa",
    "DURATION_FILTER_LABEL": "Trvanie",
    "GROUPING_OPTIONS": {
      "DAY": "Deň",
      "WEEK": "Týždeň",
      "MONTH": "Mesiac",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Otváracie hodiny",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Vymazať filter",
      "EMPTY_LIST": "Žiadne výsledky neboli nájdené"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Rozhovory: {count}",
      "RESULT_COUNT_MESSAGE": "Správy: {count}",
      "EMPTY": "Pre tento stĺpec sa nenašli žiadne záznamy.",
      "ERROR": "Záznamy sa nepodarilo načítať. Skúste to znova.",
      "LOAD_MORE": "Načítať ďalšie",
      "PREVIOUS_BUCKET": "Predchádzajúci stĺpec",
      "NEXT_BUCKET": "Ďalší stĺpec",
      "UNKNOWN_CONTACT": "Neznámy kontakt",
      "UNKNOWN_INBOX": "Neznáma schránka",
      "UNASSIGNED_AGENT": "Nepriradené",
      "NO_MESSAGE_CONTENT": "Správa nemá obsah",
      "MESSAGE_CREATED_AT": "Správa vytvorená {time}",
      "EVENT_OCCURRED_AT": "Udalosť nastala {time}",
      "INCOMING_MESSAGE": "Prichádzajúca správa",
      "OUTGOING_MESSAGE": "Odchádzajúca správa",
      "VIEW_ALL": "Zobraziť v rozhovoroch",
      "VIEW_ALL_LIMIT": "V zozname rozhovorov sa dajú otvoriť len stĺpce s najviac {limit} rozhovormi.",
      "HIDDEN_COUNT": "Nezobrazené, pretože nie ste členom ich schránky: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Zobrazuje sa {start} až {end} z {total} výsledkov",
      "PER_PAGE_TEMPLATE": "{size} / strana"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Prehľad agentov",
    "DESCRIPTION": "Ľahko sledujte výkon agentov pomocou kľúčových metrík ako konverzácie, časy odpovede, časy vyriešenia a vyriešené prípady. Kliknutím na meno agenta získate viac informácií.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_AGENT_REPORTS": "Stiahnutie reportov o agentoch",
    "FILTER_DROPDOWN_LABEL": "Vybrat agenta",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas prvej odpovede",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas prvej odpovede je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas vyriešenia je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Prehľad štítkov",
    "DESCRIPTION": "Sledujte výkon štítkov pomocou kľúčových metrík vrátane konverzácií, času odozvy, času riešenia a vyriešených prípadov.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_LABEL_REPORTS": "Stiahnuť reporty štítkov",
    "FILTER_DROPDOWN_LABEL": "Vybrať štítok",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas prvej odpovede",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas prvej odpovede je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas vyriešenia je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Prehľad schránok",
    "DESCRIPTION": "Rýchlo si pozrite výkon svojej schránky pomocou kľúčových metrík ako konverzácie, časy odpovede, časy vyriešenia a vyriešené prípady — všetko na jednom mieste. Kliknite na názov schránky pre viac detailov.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_INBOX_REPORTS": "Stiahnuť reporty schránok",
    "FILTER_DROPDOWN_LABEL": "Vybrať schránku",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas prvej odpovede",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas prvej odpovede je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas vyriešenia je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Prehľad tímov",
    "DESCRIPTION": "Získajte prehľad o výkone svojho tímu s kľúčovými metrikami, vrátane konverzácií, časov odpovede, časov vyriešenia a vyriešených prípadov. Kliknite na názov tímu pre viac detailov.",
    "LOADING_CHART": "Načítanie grafu...",
    "NO_ENOUGH_DATA": "Na vygenerovanie reportu sme nedostali dostatok dát, skúste to prosím neskôr.",
    "DOWNLOAD_TEAM_REPORTS": "Stiahnuť reporty tímov",
    "FILTER_DROPDOWN_LABEL": "Vybrať tím",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Rozhovory",
        "DESC": "( Spolu )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Prichádzajúce správy",
        "DESC": "( Spolu )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Odchádzajúce správy",
        "DESC": "( Spolu )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Čas prvej odpovede",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas prvej odpovede je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Čas do riešenia",
        "DESC": "( Priemer )",
        "INFO_TEXT": "Celkový počet konverzácií použitých pre výpočet:",
        "TOOLTIP_TEXT": "Čas vyriešenia je {metricValue} (na základe {conversationCount} konverzácií)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Počet vyriešených problémov",
        "DESC": "( Spolu )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Posledných 7 dní"
      },
      {
        "id": 1,
        "name": "Posledných 30 dní"
      },
      {
        "id": 2,
        "name": "Posledné 3 mesiace"
      },
      {
        "id": 3,
        "name": "Posledných 6 mesiacov"
      },
      {
        "id": 4,
        "name": "Posledný rok"
      },
      {
        "id": 5,
        "name": "Vlastný rozsah dátumov"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Použiť",
      "PLACEHOLDER": "Vybrať rozsah dátumov"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT reporty",
    "NO_RECORDS": "Nie sú dostupné žiadne odpovede CSAT prieskumu.",
    "DOWNLOAD": "Stiahnuť CSAT reporty",
    "DOWNLOAD_FAILED": "Nepodarilo sa stiahnuť CSAT reporty",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Vybrať agentov"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Priradený agent",
        "RATING": "Hodnotenia",
        "FEEDBACK_TEXT": "Komentár spätnej väzby"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Celkový počet odpovedí",
        "TOOLTIP": "Celkový počet získaných odpovedí"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Skóre spokojnosti",
        "TOOLTIP": "Celkový počet pozitívnych odpovedí / Celkový počet odpovedí * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Miera odpovedí",
        "TOOLTIP": "Celkový počet odpovedí / Celkový počet odoslaných CSAT prieskumných správ * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Reporty botov",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "COPILOT_COUNT": {
        "LABEL": "Počet pripravených odpovedí",
        "TOOLTIP": "Celkový počet návrhov odpovedí pripravených botom pre agentov"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      },
      "CONVERSATION_COUNT": {
        "LABEL": "Počet konverzácií",
        "TOOLTIP": "Celkový počet konverzácií so správami od bota"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Počet odpovedí",
        "TOOLTIP": "Celkový počet odchádzajúcich správ"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Počet AI odpovedí",
        "TOOLTIP": "Celkový počet odpovedí odoslaných botom"
      },
      "SUCCESS_RATE": {
        "LABEL": "Vyriešené AI",
        "TOOLTIP": "Percento konverzácií vyriešených AI bez odovzdania agentovi"
      },
      "RESOLVE_TIME": {
        "LABEL": "Čas vyriešenia",
        "TOOLTIP": "Medián času od prvej správy zákazníka po poslednú správu bota/agenta"
      }
    },
    "GROUP_BY": {
      "LABEL": "Zoskupiť podľa",
      "NONE": "Nezoskupovať",
      "INBOXES": "Schránky",
      "LABELS": "Štítky"
    },
    "GROUPED": {
      "CHART_TITLE": "Rozloženie podľa skupín",
      "BACK_TO_ALL": "Zobraziť všetko",
      "TABLE": {
        "INBOX": "Schránka",
        "LABEL": "Štítok",
        "CONVERSATIONS": "Konverzácie",
        "MESSAGES": "Správy",
        "MESSAGES_TOOLTIP": "Celkový počet odchádzajúcich správ",
        "AI_MESSAGES": "AI odpovede",
        "AI_MESSAGES_TOOLTIP": "Celkový počet AI odpovedí, za ktorým nasleduje počet pozitívnych a negatívnych hodnotení od koncových používateľov",
        "THUMBS_UP_TOOLTIP": "Počet AI odpovedí hodnotených pozitívne (palec hore) koncovými používateľmi",
        "THUMBS_DOWN_TOOLTIP": "Počet AI odpovedí hodnotených negatívne (palec dole) koncovými používateľmi",
        "AI_PERCENTAGE": "AI %",
        "AI_PERCENTAGE_TOOLTIP": "Koľko % zo všetkých správ v tejto skupine sú AI odpovede",
        "PREPARED": "Pripravené odpovede",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Koľko % správ zo všetkých správ spadá do tejto skupiny",
        "BOT_RESPONSES": "AI odpovede %",
        "SUGGESTION_USED": "Použité odpovede",
        "SUGGESTION_USED_TOOLTIP": "Koľko % z pripravených odpovedí v tejto skupine bolo použitých",
        "SUGGESTION_NOT_USED": "Nepoužité odpovede",
        "SUGGESTION_NOT_USED_TOOLTIP": "Koľko % zo všetkých správ v tejto skupine sú odpovede ktoré mali návrh ale nepoužil sa"
      },
      "NOTES": {
        "TITLE": "Ako sa metriky počítajú",
        "CONVERSATIONS": "Počet konverzácií, ktoré majú aspoň jednu odchádzajúcu správu vo vybranom období.",
        "MESSAGES": "Celkový počet odchádzajúcich (nesúkromných) správ odoslaných vo vybranom období. Zahŕňa správy vytvorené AI aj agentmi.",
        "PERCENTAGE": "Podiel správ tejto skupiny zo všetkých odchádzajúcich správ naprieč všetkými skupinami.",
        "AI_MESSAGES": "Počet odchádzajúcich správ odoslaných automaticky AI botom (nezahŕňa pripravené odpovede pre agentov). Čísla v zátvorkách ukazujú, koľko z týchto odpovedí hodnotili koncoví používatelia pozitívne (palec hore) a negatívne (palec dole).",
        "BOT_RESPONSES_PCT": "Podiel AI odpovedí zo všetkých odchádzajúcich správ v tejto skupine.",
        "PREPARED": "Počet návrhov odpovedí (pripravených odpovedí) vygenerovaných AI botom pre agentov vo vybranom období. Ide o súkromné správy viditeľné iba agentom a nie sú započítané ako odchádzajúce správy, takže toto číslo nemusí korelovať so stĺpcom Správy.",
        "SUGGESTION_USED": "Koľko percent z pripravených odpovedí v tejto skupine bolo použitých agentmi. Nemusí korelovať s počtom pripravených odpovedí, pretože môže zahŕňať aj návrhy vygenerované v predchádzajúcich obdobiach.",
        "SUGGESTION_NOT_USED": "Percento odchádzajúcich správ v tejto skupine, kde bol návrh copilota k dispozícii, ale agent odpovedal bez jeho použitia. Započítava sa iba vtedy, keď agent skutočne odoslal odpoveď. Nemusí korelovať s počtom pripravených odpovedí, pretože môže zahŕňať aj návrhy vygenerované v predchádzajúcich obdobiach."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Prehľad",
    "LIVE": "Naživo",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Otvorené konverzácie",
      "LOADING_MESSAGE": "Načítavajú sa metriky konverzácií...",
      "OPEN": "Otvoriť",
      "UNATTENDED": "Nevybavené",
      "UNASSIGNED": "Nepriradené",
      "PENDING": "Čaká sa na"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Prevádzka konverzácií",
      "NO_CONVERSATIONS": "Žiadne konverzácie",
      "CONVERSATION": "{count} konverzácia",
      "CONVERSATIONS": "{count} konverzácií",
      "DOWNLOAD_REPORT": "Stiahnuť report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Konverzácie podľa agentov",
      "LOADING_MESSAGE": "Načítavajú sa metriky agentov...",
      "NO_AGENTS": "Nie sú žiadne konverzácie podľa agentov",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Otvoriť",
        "UNATTENDED": "Nevybavené",
        "STATUS": "Stav"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "Všetky tímy",
      "HEADER": "Konverzácie podľa tímov",
      "LOADING_MESSAGE": "Načítavajú sa metriky tímov...",
      "NO_TEAMS": "Nie sú dostupné žiadne dáta",
      "TABLE_HEADER": {
        "TEAM": "Tím",
        "OPEN": "Otvoriť",
        "UNATTENDED": "Nevybavené",
        "STATUS": "Stav"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Stav agenta",
      "ONLINE": "Online",
      "BUSY": "Zaneprázdnený",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Nedeľa",
    "MONDAY": "Pondelok",
    "TUESDAY": "Utorok",
    "WEDNESDAY": "Streda",
    "THURSDAY": "Štvrtok",
    "FRIDAY": "Piatok",
    "SATURDAY": "Sobota"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA reporty",
    "NO_RECORDS": "Konverzácie s aplikovaným SLA nie sú dostupné.",
    "LOADING": "Načítavajú sa SLA dáta...",
    "DOWNLOAD_SLA_REPORTS": "Stiahnuť SLA reporty",
    "DOWNLOAD_FAILED": "Nepodarilo sa stiahnuť SLA reporty",
    "DROPDOWN": {
      "ADD_FIlTER": "Pridať filter",
      "CLEAR_ALL": "Vymazať všetko",
      "CLEAR_FILTER": "Vymazať filter",
      "EMPTY_LIST": "Žiadne výsledky neboli nájdené",
      "NO_FILTER": "Nie sú dostupné žiadne filtre",
      "SEARCH": "Hľadať filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "Názov SLA",
        "AGENTS": "Meno agenta",
        "INBOXES": "Názov schránky",
        "LABELS": "Názov štítku",
        "TEAMS": "Názov tímu"
      },
      "SLA": "SLA politika",
      "INBOXES": "Schránka",
      "AGENTS": "Agent",
      "LABELS": "Štítok",
      "TEAMS": "Tím"
    },
    "WITH": "s",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Miera splnenia",
        "TOOLTIP": "Percento úspešne dokončených vytvorených SLA"
      },
      "NO_OF_MISSES": {
        "LABEL": "Počet porušení",
        "TOOLTIP": "Celkový počet porušení SLA v určitom období"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Počet konverzácií",
        "TOOLTIP": "Celkový počet konverzácií so SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Politika",
        "CONVERSATION": "Konverzácia",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Zobraziť detaily"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Medzisúčet",
    "NO_TEAM": "Bez tímu",
    "GROUP_BY_TEAMS": "Zoskupiť podľa tímov",
    "INBOX": "Schránka",
    "AGENT": "Agent",
    "TEAM": "Tím",
    "LABEL": "Štítok",
    "AVG_RESOLUTION_TIME": "Priemerný čas vyriešenia",
    "AVG_FIRST_RESPONSE_TIME": "Priemerný čas prvej odpovede",
    "AVG_REPLY_TIME": "Priemerný čas čakania zákazníka",
    "RESOLUTION_COUNT": "Počet vyriešených problémov",
    "CONVERSATIONS": "Počet konverzácií",
    "TOTAL": "Celkom",
    "OUTGOING_CHATS": "Odchádzajúce chaty",
    "OUTGOING_EMAILS": "Odchádzajúce e-maily",
    "PHONE_CALLS": "Telefónne hovory",
    "INBOUND_CALLS": "Prichádzajúce hovory",
    "OUTBOUND_CALLS": "Odchádzajúce hovory",
    "TOTAL_ACTIVITIES": "Celkové aktivity",
    "ONLINE_TIME": "Čas online",
    "QUEUE_AVAILABLE_TIME": "Čas dostupnosti vo fronte",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Počet odchádzajúcich správ odoslaných týmto agentom",
      "OUTGOING_EMAILS": "Počet odchádzajúcich e-mailov odoslaných týmto agentom",
      "PHONE_CALLS": "Celkový počet telefónnych hovorov priradených tomuto agentovi (súčet prichádzajúcich a odchádzajúcich hovorov)",
      "TOTAL_ACTIVITIES": "Celkový počet aktivít: prichádzajúce hovory + odchádzajúce hovory + odchádzajúce chaty + odchádzajúce e-maily",
      "INBOUND_CALLS": "Počet prichádzajúcich telefónnych hovorov priradených tomuto agentovi",
      "OUTBOUND_CALLS": "Počet odchádzajúcich telefónnych hovorov priradených tomuto agentovi",
      "AVG_FIRST_RESPONSE_TIME": "Priemerný čas od vytvorenia konverzácie po prvú odpoveď agenta v konverzáciách priradených tomuto agentovi",
      "AVG_RESOLUTION_TIME": "Priemerný čas od vytvorenia konverzácie po vyriešenie v konverzáciách priradených tomuto agentovi",
      "AVG_REPLY_TIME": "Priemerný čas, ktorý zákazníci čakajú medzi svojou správou a odpoveďou agenta v konverzáciách priradených tomuto agentovi",
      "ONLINE_TIME": "Celkový čas, počas ktorého bol agent online alebo zaneprázdnený v priebehu zvoleného obdobia",
      "QUEUE_AVAILABLE_TIME": "Celkový čas, počas ktorého bol agent dostupný v telefónnych frontoch v priebehu zvoleného obdobia"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefónne reporty",
    "DESCRIPTION": "Sledujte metriky telefónnych hovorov s podrobnými prehľadmi prichádzajúcich a odchádzajúcich hovorov, zoskupené podľa agenta alebo schránky pre komplexnú analýzu.",
    "AGENT_HEADER": "Telefónne reporty - Podľa agenta",
    "INBOX_HEADER": "Telefónne reporty - Podľa schránky",
    "DOWNLOAD_BUTTON": "Stiahnuť telefónne reporty",
    "DOWNLOAD_PHONE_REPORTS": "Stiahnuť telefónne reporty",
    "GROUP_BY": {
      "LABEL": "Zoskupiť podľa",
      "AGENT": "Agenta",
      "INBOX": "Schránky"
    },
    "TABLE": {
      "AGENT_NAME": "Meno agenta",
      "INBOX_NAME": "Názov schránky",
      "TOTAL_CALLS": "Celkom",
      "INBOUND_CALLS": "Prichádzajúce",
      "OUTBOUND_CALLS": "Odchádzajúce",
      "FAILED_OUTBOUND_CALLS": "Neúspešné odchádzajúce",
      "AVG_AGENT_HANDLED_DURATION": "Priemerná dĺžka",
      "TOTAL_AGENT_HANDLED_DURATION": "Celková dĺžka",
      "AVG_RINGING_TIME": "Priemerný čas zvonenia",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Úspešnosť %",
      "UNIQUE_CALLERS": "Unikátni volajúci",
      "UNIQUE_CALLED_CONTACTS": "Unikátne volané",
      "UNANSWERED_MISSED_CALLS": "Zmeškané bez reakcie",
      "UNANSWERED_MISSED_PERCENTAGE": "Zmeškané bez reakcie %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Zmeškané bez reakcie, nedostatočne opätovne volané",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Zmeškané bez reakcie, nedostatočne opätovne volané %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Celkový počet všetkých hovorov (vrátane nespojených)",
      "INBOUND_CALLS": "Počet spojených hovorov",
      "OUTBOUND_CALLS": "Počet všetkých odchádzajúcich hovorov (vrátane nespojených)",
      "FAILED_OUTBOUND_CALLS": "Počet odchádzajúcich hovorov, ktoré sa nepodarilo spojiť",
      "AVG_AGENT_HANDLED_DURATION": "Priemerná dĺžka hovorov spracovaných agentmi",
      "TOTAL_AGENT_HANDLED_DURATION": "Celková dĺžka všetkých hovorov spracovaných agentmi",
      "AVG_RINGING_TIME": "Priemerný čas, ktorý hovory strávili zvonením pred zodpovedaním",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Percento odchádzajúcich hovorov, ktoré boli úspešne spojené",
      "UNIQUE_CALLERS": "Počet unikátnych kontaktov, ktoré uskutočnili prichádzajúce hovory",
      "UNIQUE_CALLED_CONTACTS": "Počet unikátnych kontaktov, ktorým bol uskutočnený odchádzajúci hovor",
      "UNANSWERED_MISSED_CALLS": "Počet zmeškaných hovorov, pri ktorých nebolo úspešné spätné volanie (hovor spojený). Môže zahŕňať hovory, ktoré je stále možné spracovať v priebehu pracovného dňa",
      "UNANSWERED_MISSED_PERCENTAGE": "Percento unikátnych volajúcich, ktorých hovory boli zmeškané bez reakcie (zmeškané nezodpovedané hovory / unikátni volajúci)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Počet zmeškaných hovorov s menej ako 2 pokusmi o spätné volanie. Môže zahŕňať hovory, ktoré je stále možné spracovať v priebehu pracovného dňa",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Percento unikátnych volajúcich s menej ako 2 pokusmi o spätné volanie ((zmeškané bez reakcie - dostatočne spracované) / unikátni volajúci)"
    },
    "EMPTY_STATE": {
      "TITLE": "Nie sú dostupné žiadne údaje o telefónnych hovoroch",
      "MESSAGE": "V zvolenom časovom rozsahu nie sú žiadne telefónne hovory. Skúste upraviť filtre alebo časový rozsah."
    }
  }
}
